
import React from 'react';
import '../App.css';

export default function Services() {

  const Logo = "images/icon/am02.png";

  return (
    <>

      <div className='sign-up'>
          <img src={ Logo } alt="AgroMax" />
      </div>
      
    </>
  );
}